export function getRedirectLocationAfterGroupJoin(groupCode: string): string;
export function getRedirectLocationAfterGroupJoin(group: { getCodeOrError: () => void }): string;
export default function getRedirectLocationAfterGroupJoin(
  group: string | { getCodeOrError: () => void }
): string {
  if (typeof group === 'string') {
    return `/classes/${group}/messages`;
  }
  return `/classes/${group.getCodeOrError()}/messages`;
}
